<template>
  <MapModal
    :modalNode="modalNode"
    :close="cancel"
    :title="routeInteractionTitle"
    id="routeInteraction"
  >
    <template slot="content">
      <schemeDesignLine
        ref="schemeDesignLine"
        @getPlanGuid="getPlanGuid($event)"
        @getDesignLineGuid="getDesignLineGuid($event)"
      ></schemeDesignLine>

      <div class="positioning">
        <span>起终点桩号</span>
        <div>
          <el-input v-model="stake1" disabled></el-input>
          <span>~</span>
          <el-input v-model="stake2" disabled></el-input>
        </div>
      </div>
      <el-table
        :data="tableData"
        class="tableClass"
        style="width: 100%;margin-bottom: 20px;"
      >
        <el-table-column prop="type" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="value" align="center" label="值">
        </el-table-column>
        <el-table-column prop="unit" align="center" label="单位">
        </el-table-column>
      </el-table>
    </template>
    <template slot="foot">
      <div class="foot-operate">
        <el-button type="primary" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" @click="pointPick">
          拾取
        </el-button>
        <el-button type="primary" @click="onSubmit">
          统计
        </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () => import("./schemeDesignLine.vue");

import {
  getVolumeService,
  getGetStakeByBLH,
  getsectionAreaByLineService,
  getPointService,
} from "@/api/api";
import * as mapWork from "./map.js";

export default {
  name: "routeInteraction",
  components: { MapModal, schemeDesignLine },
  props: ["close"],
  data() {
    return {
      routeInteractionTitle: "统计土石方",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      planGuid: null,
      designLineGuid: null,
      stake1: null,
      stake2: null,
      designLineGuid1: null,
      designLineGuid2: null,
      tableData: [],
      position: [],
    };
  },
  methods: {
    cancel() {
      mapWork.clearLayer();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
    },
    pointPick() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      mapWork.createLayer();
      if (this.position.length > 1) {
        mapWork.graphicDotsine.clear();
        mapWork.graphicDotsineLine.clear();
        this.stake1 = null;
        this.stake2 = null;
        this.position = [];
      }
      mapWork.createEarthworkPoint();
      mapWork.graphicDotsine.on(mars3d.EventType.drawCreated, (e) => {
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          e.graphic._position_draw
        );
        let position = [_lng, _lat, _alt];
        const params = {
          planGuid: this.planGuid,
          // designLineGuid: this.designLineGuid,
          l: position[0],
          b: position[1],
          h: position[2],
        };
        getGetStakeByBLH(params).then((res) => {
          console.log(res);
          if (res.data.statusCode !== 500) {
            const { stake1, stake2, designLineGuid } = res.data.data;
            e.layer.setStyle({
              label: {
                text: `桩号: ${stake1}`,
              },
            });
            this.position.push(position);
            if (this.position.length > 1) {
              mapWork.createEarthworkLine(this.position);
              mapWork.graphicDotsine.off();
              this.stake2 = stake2;
              this.designLineGuid2 = designLineGuid;
              this.tableData = [];
            } else {
              this.stake1 = stake2;
              this.designLineGuid1 = designLineGuid;
              mapWork.createEarthworkPoint();
            }
          } else {
            this.position = [];
            this.stake1 = null;
            this.stake2 = null;

            mapWork.graphicDotsine.off();
            mapWork.graphicDotsine.clear();
            mapWork.graphicDotsineLine.clear();
            return this.$notify({
              title: res.data.errors,
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        });
        // getsectionAreaByLineService({
        //   planGuid: this.planGuid,
        //   designLineGuid: this.designLineGuid,
        //   b: _lat,
        //   l: _lng,
        //   h: _alt,
        // }).then((res) => {
        //   if (res.data.statusCode !== 500) {
        //     this.tableData = [
        //       {
        //         type: "填方",
        //         value: res.data.data.t,
        //         unit: "m³",
        //       },
        //       {
        //         type: "挖方",
        //         value: res.data.data.w,
        //         unit: "m³",
        //       },
        //     ];
        //   } else {
        //     this.tableData = [];
        //     mapWork.graphicDotsine.clear();
        //     return this.$notify({
        //       title: res.data.errors,
        //       message: "",
        //       type: "error",
        //       duration: 1000,
        //       offset: 320,
        //     });
        //   }
        // });
      });
    },
    // 确定
    onSubmit() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      if (!this.stake1 || !this.stake2) {
        return this.$notify({
          title: "请填写起终点桩号",
          message: "",
          type: "error",
          duration: 1000,
          offset: 320,
        });
      }
      const params = {
        planGuid: this.planGuid,
        // designLineGuid: this.designLineGuid,
        stake1: this.stake1,
        designLineGuid1: this.designLineGuid1,
        stake2: this.stake2,
        designLineGuid2: this.designLineGuid2,
      };
      getVolumeService(params).then((res) => {
        if (res.data.statusCode !== 500) {
          this.tableData = [
            {
              type: "填方",
              value: res.data.data.t,
              unit: "m³",
            },
            {
              type: "挖方",
              value: res.data.data.w,
              unit: "m³",
            },
          ];
        } else {
          this.tableData = [];
          return this.$notify({
            title: res.data.errors,
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.el-input {
  @include input_base();
  width: 58px;
  border-color: rgba(245, 245, 245, 0.6) !important;
}
/deep/ .el-input__inner {
  width: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: none;
  padding: 0 5px;
  font-size: 12px;
  height: 25px !important;
  line-height: 25px;
  border-color: rgba(245, 245, 245, 0.6) !important;
  color: #fff;
}
.positioning {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  // margin-bottom: 20px;
  margin-right: 60px;
  font-size: 12px;
  color: #fff;
  span {
    padding-right: 10px;
    padding-left: 7px;
  }
  /deep/ div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background-color: transparent;
}
/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 13px;
}
/deep/.el-table th.el-table__cell > .cell {
  color: #ffffff;
}
/deep/.el-table td.el-table__cell,
/deep/.el-table th.el-table__cell.is-leaf {
  border: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: none;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
</style>
